import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionRestriction } from '../../models/subscription.models';
import { RestrictionTypes } from '../../enums/subscription-enum';

@Component({
  selector: 'app-subscription-restriction',
  templateUrl: './subscription-restriction.component.html',
  styleUrl: './subscription-restriction.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionRestrictionComponent implements OnInit {

  @Input() isMobileApp: boolean = false;
  @Input() subscriptionData: SubscriptionRestriction;

  header: string;
  billingAdmins: any[];
  siteName: string = '';
  emailContent: any = '';
  userName: string = '';

  ngOnInit() {
    if (this.subscriptionData) {

      const { restrictionType, billingAdmins, siteName, userName } = this.subscriptionData;

      if (restrictionType === RestrictionTypes.Tier_Upgrade) {
        this.header = 'Tier Upgrade Required';
      }

      this.billingAdmins = billingAdmins ?? [];
      this.siteName = siteName ?? '';
      this.userName = userName ?? '';

      this.initializeMailContent();
    }
  }

  initializeMailContent() {
    let billingAdminEmails = this.billingAdmins?.map((admin: any) => admin.emailId);

    const emailSubject = encodeURIComponent(`Upgrade Plan for Full Access to ${this.siteName}’s Features!`);
    const emailBody = encodeURIComponent(
      `Hi,

The site "${this.siteName}" is currently on a lower subscription tier and requires an upgrade to access the full set of features. To ensure uninterrupted service and unlock the full range of capabilities, please consider upgrading the subscription to a higher tier.


Thank you for your support.
Best regards,
${this.userName}`);

    this.emailContent = `mailto:${billingAdminEmails}?subject=${emailSubject}&body=${emailBody}`
  }
}

